module.exports = __webpack_public_path__ + "img/summary-item-bg.c090e3b2.png";